import styled from '@emotion/styled'
import { spacing, Text } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const SchoolSummaryContainer = styled.div`
  margin-top: ${spacing.majorScale(3)}px;
`

export const TimesContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
`

export const ConfirmationText = styled(Text)`
  margin-bottom: 1rem;
`
